import React, { useRef, useState } from 'react';
import { AiOutlinePlusCircle } from 'react-icons/ai';
import { BiMinusCircle } from 'react-icons/bi';
import './accordion.css';
import PropTypes from 'prop-types';

const Accordion = ({ content, title, section, isResto }) => {
  const [isActive, setIsActive] = useState(false);
  // Mantiene el contenido montado mientras corre la animación de cierre
  const [isClosing, setIsClosing] = useState(false);
  const contentRef = useRef(null);
  const Component = content;

  const toggle = () => {
    if (isActive && !isClosing) {
      // Altura real de partida para que la animación colapse hasta 0
      contentRef.current.style.setProperty(
        '--accordion-height',
        `${contentRef.current.scrollHeight}px`
      );
      setIsClosing(true);
    } else {
      setIsActive(true);
      setIsClosing(false);
    }
  };

  const handleAnimationEnd = (e) => {
    if (isClosing && e.target === e.currentTarget) {
      setIsActive(false);
      setIsClosing(false);
    }
  };

  return (
    <div className="accordion-item">
      <div className="accordion-title" onClick={toggle}>
        <div>{title}</div>
        <div className="iconsContainer">
          {isActive && !isClosing ? <BiMinusCircle /> : <AiOutlinePlusCircle />}
        </div>
      </div>
      {isActive && (
        <div
          ref={contentRef}
          className={`accordion-content${isClosing ? ' is-closing' : ''}`}
          onAnimationEnd={handleAnimationEnd}
        >
          <Component section={section} isResto={isResto} />
        </div>
      )}
    </div>
  );
};
Accordion.propTypes = {
  content: PropTypes.any,
  section: PropTypes.any,
  title: PropTypes.string,
  isResto: PropTypes.bool,
};

export default Accordion;
